import toPairs from 'lodash/toPairs';
import get from 'lodash/get';
import platform from 'platform';
import serializeError from 'serialize-error';
// this is for flatting objects, vs. lodash that can flatten only arrays
import flat from 'flat';

// ours
import { commonStore } from 'stores/common';

export const findUserId = () => {
    let userId = get(commonStore, 'user.id');
    if (!userId) {
        try {
            userId = JSON.parse(localStorage.getItem('common')).user.id;
        } catch (e) {
            // we failed to find user id
        }
    }
    return userId;
};

// flatten and format object keys and values to a readable string for Kibana, etc.
export const toString = (obj = {}) =>
    toPairs(flat(obj))
        .map((pair) => pair.join(': '))
        .join(', ');

export const prepareSubscription = (subscription) => {
    const subscriptionCoreData =
        subscription ||
        get(commonStore, 'subscription._source.current_plan.core_plan_data');

    if (!subscriptionCoreData) return;

    return toString(subscriptionCoreData);
};

export const prepareLeanplumVariables = () => {
    const leanplumVariables =
        window.Leanplum &&
        typeof window.Leanplum.getVariable === 'function' &&
        window.Leanplum.getVariable();

    if (!leanplumVariables) return;

    const { Revenue, RevenueWeb } = leanplumVariables;

    return {
        leanplum_revenue: toString(Revenue),
        leanplum_revenueWeb: toString(RevenueWeb),
    };
};

// message should be a human readable description of what went wrong
// error can be some stack trace or the whole error object that browser gives
export const prepareErrorPayload = (message, error = {}) => {
    const payload = {};

    try {
        payload['data'] = {
            error: {
                message,
                error: JSON.stringify(serializeError(error)),
            },
            page: {
                host_name: window.location.hostname,
                path: window.location.pathname,
                url: document.URL,
                title: document.title,
                protocol: window.location.protocol,
            },
            user: {
                id: findUserId(),
            },
            subscription_core_data: prepareSubscription(),
            ...prepareLeanplumVariables(),
            device: {
                description: platform.description,
                browser: platform.name,
                browser_version: platform.version,
                product: platform.product, // 'iPad'
                engine: platform.layout, // 'WebKit'
                manufacturer: platform.manufacturer, // 'Apple'
            },
        };

        return JSON.stringify(payload);
    } catch (e) {
        console.error('Failed to prepare error payload.', e);
    }
};
